import React, { FunctionComponent, ReactNode, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import classnames from 'classnames'
import ReactTooltip from 'react-tooltip'

import { ErrorContainer } from '../../../containers'
import Side from './Side'
import Top from './Top'

import { MenuItem } from './Side/Item'
import { UserStore } from '../../../typings/stores/UserStore'
import { Website } from '../../../typings/website'

import styles from './styles.module.css'
import { ENABLE_MYFI_REPORTS } from '../../../utils/featureFlags'

interface AppFrameProps {
  user: UserStore
  children: ReactNode
  updateActiveWebsite(w: Website): void
}

const old: MenuItem[] = [
  // MyFi Non Loans Tab
  {
    name: 'MyFi Reports',
    icon: 'report',
    path: '/app/myfi-reports',
  },
  {
    name: 'Overview',
    icon: 'overview',
    path: '/app/dashboard',
  },
  {
    name: 'Direct Reports',
    icon: 'report',
    path: '/app/reports',
  },
  {
    name: 'Referral Reports',
    icon: 'report',
    path: '/app/banner-referrals',
  },
  {
    name: 'Advertisers',
    icon: 'advertiser',
    path: '/app/advertisers',
  },
  {
    name: 'Links',
    icon: 'link',
    path: '/app/links',
  },
  {
    name: 'Link Info',
    icon: 'laptop-code',
    className: styles.link,
    path: '/app/link-info',
  },
  {
    name: 'Payments',
    icon: 'payment',
    path: '/app/payments',
    minimumRequiredRole: 'admin',
  },
  {
    name: 'Alerts',
    icon: 'alert',
    path: '/app/alerts',
  },
  {
    name: 'Support',
    icon: 'support',
    path: '/app/support',
  },
]
const withoutMyFiReportsOld: MenuItem[] = [
  {
    name: 'Overview',
    icon: 'overview',
    path: '/app/dashboard',
  },
  {
    name: 'Advertisers',
    icon: 'advertiser',
    path: '/app/advertisers',
  },
  {
    name: 'Links',
    icon: 'link',
    path: '/app/links',
  },
  {
    name: 'Link Info',
    icon: 'laptop-code',
    className: styles.link,
    path: '/app/link-info',
  },
  {
    name: 'Reports',
    icon: 'report',
    path: '/app/reports',
  },
  {
    name: 'Referral Reports',
    icon: 'report',
    path: '/app/banner-referrals',
  },
  {
    name: 'Payments',
    icon: 'payment',
    path: '/app/payments',
    minimumRequiredRole: 'admin',
  },
  {
    name: 'Alerts',
    icon: 'alert',
    path: '/app/alerts',
  },
  {
    name: 'Support',
    icon: 'support',
    path: '/app/support',
  },
]

const menuList: MenuItem[] = [
  {
    name: 'Overview',
    icon: 'overview',
    path: '/new/dashboard',
  },
  {
    name: 'Advertisers',
    icon: 'advertiser',
    path: '/new/advertisers',
  },
  {
    name: 'Links',
    icon: 'link',
    path: '/new/links',
  },
  {
    name: 'Link Info',
    icon: 'laptop-code',
    className: styles.link,
    path: '/new/link-info',
  },
  {
    name: 'Reports',
    icon: 'report',
    path: '/new/reports',
  },
  {
    name: 'Payments',
    icon: 'payment',
    path: '/new/payments',
    minimumRequiredRole: 'admin',
  },
  {
    name: 'Alerts',
    icon: 'alert',
    path: '/new/alerts',
  },
  {
    name: 'Support',
    icon: 'support',
    path: '/new/support',
  },
]

const AppFrame: FunctionComponent<AppFrameProps> = ({
  user,
  children,
  updateActiveWebsite,
}) => {
  const location = useLocation()
  const [which, setWhich] = useState('old')
  let isFiltered = false

  useEffect(() => {
    setWhich(location.pathname.split('/').includes('new') ? 'new' : 'old')
  }, [location])

  // Verify feature flag for MyFi Reports and remove items from Menu if disabled
  let filteredOld = old

  if (!ENABLE_MYFI_REPORTS) {
    filteredOld = withoutMyFiReportsOld
    isFiltered = true
  }

  return (
    <div className={styles.container} data-rv="app-frame">
      <Side
        className={classnames(
          !isFiltered && styles.highlight,
          styles.left,
          styles.column
        )}
        menuList={which == 'new' ? menuList : filteredOld}
      />
      <div className={classnames(styles.right, styles.column)}>
        <ErrorContainer />
        <Top
          className={styles.topContainer}
          userName={`${user.firstName} ${user.lastName}`}
          userInitials={`${user.firstName.charAt(0)}${user.lastName.charAt(0)}`}
          activeWebsite={user.activeWebsite}
          websites={user.websites}
          updateActiveWebsite={updateActiveWebsite}
        />
        <div className={styles.content} data-rv="content">
          {children}
        </div>
        <ReactTooltip
          id="global-tooltip"
          role="tooltip"
          place="left"
          effect="float"
          className={styles.tooltip}
        />
      </div>
    </div>
  )
}

export default AppFrame
